import axios from 'axios';

const instance = axios.create({});

const axiosInstance = {
  // export all axios default properties
  ...instance,
};

export default axiosInstance;
